module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/short-black-hair-smiling/short-black-hair-smiling@3x.png"